/**
 * Landing — the signed-out entry point (desktop).
 * `design/GT Crew.dc.html` · `data-screen-label="Landing"`.
 *
 * Same two doors as the phone column, at the desktop's measurements: a 680px
 * column, larger coin and wordmark, and the CTAs side by side rather than
 * stacked. Rendered without the header — `headerVM().authed` is false here.
 *
 * NO PITCH LINE, NO FEATURE GRID, NO FOOTER — deliberate, and the same story as
 * the phone screen. The changelog describes all three; Marcus deleted them
 * because he did not think they looked good (confirmed 2026-08-19) and the
 * edit never made it back into the changelog. The mirrors' empty divs are the
 * live spec, not a lossy export. Do not restore them.
 */

import { PixelButton } from '../../components/PixelButton.tsx';
import { QuarterIcon } from '../../components/QuarterIcon.tsx';
import { useQd } from '../../store/index.ts';
import { landingVM } from '../../store/selectors.ts';

export default function Landing(): JSX.Element {
  const s = useQd();
  const v = landingVM(s);
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '60px 24px 34px',
        boxSizing: 'border-box',
      }}
    >
      <div
        style={{
          width: '680px',
          maxWidth: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <QuarterIcon u={3} />
        <div
          style={{
            fontFamily: 'var(--gt-font-pixel)',
            fontSize: '22px',
            color: 'var(--gt-text)',
            lineHeight: 1.6,
            marginTop: '18px',
          }}
        >
          GAMES TONIGHT<span style={{ color: 'var(--acc2)' }}>?</span>
        </div>

        {v.signedIn ? (
          <div
            style={{
              fontFamily: 'var(--gt-font-mono)',
              fontSize: '9.5px',
              lineHeight: 1.8,
              letterSpacing: '.06em',
              textAlign: 'center',
              marginTop: '20px',
            }}
          >
            <div style={{ color: 'var(--gt-muted-2)' }}>{v.whoLbl}</div>
            <div style={{ color: 'var(--gt-text-5)', overflowWrap: 'anywhere' }}>{v.whoTxt}</div>
          </div>
        ) : null}

        <div
          style={{
            display: 'flex',
            gap: '12px',
            marginTop: '28px',
            flexWrap: 'wrap',
            justifyContent: 'center',
          }}
        >
          <PixelButton
            label="START A PARTY ▸"
            onClick={s.openWizard}
            fs="10"
            pad="16px 20px"
            nowrap
          />
          <PixelButton
            label={v.altLbl}
            variant="outline"
            onClick={() => (v.crewless ? s.signOut() : s.nav('login'))}
            fs="10"
            pad="16px 20px"
            nowrap
          />
        </div>

        {/* Signed in, no crew — see `landingVM`. The mirrors never drew this
            state because their accounts cannot outlive their crew; ours can. */}
        {v.crewless ? (
          <div
            style={{
              fontFamily: 'var(--gt-font-mono)',
              fontSize: '10.5px',
              lineHeight: 1.7,
              letterSpacing: '.04em',
              color: 'var(--gt-muted)',
              marginTop: '20px',
            }}
          >
            {v.noteTxt}
          </div>
        ) : null}
      </div>
    </div>
  );
}
